import { render, staticRenderFns } from "./orderInfoWindow.vue?vue&type=template&id=7687431c&scoped=true"
import script from "./orderInfoWindow.vue?vue&type=script&lang=js"
export * from "./orderInfoWindow.vue?vue&type=script&lang=js"
import style0 from "./orderInfoWindow.vue?vue&type=style&index=0&id=7687431c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7687431c",
  null
  
)

export default component.exports